// 车辆信息维护
export default {
  namespaced: true,
  state: {
    isDangerous: false, // 是否为危化车
    carType: '', // 车辆类型
  },
  mutations: {
    getIsDangerous(state, data) {
      state.isDangerous = data;
    },
    getCarType(state, data) {
      console.log('dataVuex', data);
      state.carType = data;
    },
  }
}